import { useCallback, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";

import { useDialogsProvider } from "2g-dialogs-provider";
import ZpracDialog from "2g-zprac-dialog";
import { actions as formActions, useFieldValue } from "2g-form";
import { dispatchModuleAction } from "2g-utils-redux";

import { useSmlouva } from "b2b/api/hooks";
import { ADMIN } from "b2b/api/paths";
import { useRedirect } from "b2b/hooks";
import { PATHS } from "b2b/constants";

import createSmlouvaVytvoreniRequest from "./utils/createSmlouvaVytvoreniRequest";
import useMessages from "./i18n/useMessages";

export const FORM_MODULE_KEY = "smlouvaVytvoreni";

export default function useSmlouvaVytvoreni({ zakaznik }) {
  const { id } = useParams();
  const dispatch = useDispatch();
  const loader = useSmlouva({ id });
  const redirect = useRedirect();
  const { saveDialogTitle } = useMessages();
  const { showDialog, hideDialog } = useDialogsProvider();

  const fixniNaroky = useFieldValue("fixniNaroky", FORM_MODULE_KEY);

  const redirectToZakaznik = useCallback(() => {
    redirect(
      PATHS.ADMINISTRACE.ZAKAZNIK,
      {
        ico: zakaznik.ico
      },
      { state: { openGrid: "smlouvy" } }
    );
  }, [redirect, zakaznik]);

  const handleSuccess = useCallback(() => {
    hideDialog();
    redirectToZakaznik();
  }, [hideDialog, redirectToZakaznik]);

  const handleSubmit = useCallback(
    ({ values, submitter }) => {
      showDialog(ZpracDialog, {
        url: ADMIN.smlouva(id),
        method: id ? "put" : "post",
        payload: createSmlouvaVytvoreniRequest(values, zakaznik),
        title: saveDialogTitle(),
        onClose: hideDialog,
        onSuccess: handleSuccess
      });
    },
    [zakaznik, showDialog, handleSuccess, id]
  );

  useEffect(() => {
    loader.data &&
      dispatchModuleAction(
        dispatch,
        FORM_MODULE_KEY,
        formActions.setValues(loader.data)
      );
  }, [loader.data]);

  return {
    formModuleKey: FORM_MODULE_KEY,
    isEdit: !!id,
    isPouzito: Boolean(loader.data?.pouzito),
    loader,
    onSubmit: handleSubmit,
    onCancel: redirectToZakaznik,
    isDefaultNarokyHidden: Boolean(fixniNaroky)
  };
}
